// extracted by mini-css-extract-plugin
export default {"container":"ResetPassword_container__XKZ7G","message":"ResetPassword_message__GJG02","error":"ResetPassword_error__B7bCN"};